import { Typography, TypographyProps } from "@mui/material";
import React from "react";

type MultirowEllipsisTypographyProps = TypographyProps & {
  maxRows?: number;
};

export const MultirowEllipsisTypography = ({
    maxRows,
    sx,
    ...props
}: MultirowEllipsisTypographyProps) => (
    <Typography
        sx={{
            display: "-webkit-box",
            overflow: "hidden",
            textOverflow: "ellipsis",
            WebkitLineClamp: maxRows,
            WebkitBoxOrient: "vertical",
            ...sx,
        }}
        {...props}
    >
        {props.children}
    </Typography>
);
